<template>
  <div class="tw-relative tw-w-full">
    <p class="tw-text-gray-600 tw-text-right">{{ completed }}%</p>
    <div class="tw-h-1.5 tw-bg-white tw-rounded-full">
      <div class="tw-bg-primary-600 tw-rounded-full tw-h-full" :style="{ width: `${completed}%` }"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "progress-arc",
  props: {
    completed: {
      type: Number,
      default: 1,
    }
  }
});
</script>